import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class DatevTenantService<T extends EMode = EMode.entity> {
  /** Alias: name */
  name?: string;
  /** Alias: scopes */
  scopes?: string[];

  __typename?: string;
}

const fields: FieldDefinitions<DatevTenantService> = {
  name: {
    alias: 'name',
  },
  scopes: {
    alias: 'scopes',
  },
  __typename: {
    alias: '__typename',
  },
};

export const datevTenantServiceEntityDefinition: EntitiyDefinition<DatevTenantService> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'DatevTenantService',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
